import styled, { css } from 'styled-components';
import { mediaBreakpointUp } from '@whitelabel/helpers/style';
import { Layout } from '../components';

export const StyledLayout = styled(Layout)<{ $hiddenNav?: boolean }>`
  > div {
    margin-bottom: 1.5rem;

    ${({ $hiddenNav }) =>
      $hiddenNav &&
      css`
        padding-top: 1.5rem;
      `}

    ${mediaBreakpointUp('md')`
      margin-bottom: 2rem;
    `};

    ${mediaBreakpointUp('lg')`
      margin-bottom: 3rem;

    ${({ $hiddenNav }: { $hiddenNav: boolean }) =>
      $hiddenNav &&
      css`
        padding-top: 3rem;
      `}
    `};
  }
`;

export default StyledLayout;
